export function get_short_examples(t = (x) => x) {
	return [
		{
			href: '/companies/gr/757001000/',
			name: 'Metlen Energy & Metals',
			afm: '094316669',
		},
		{
			href: '/companies/gr/154558160000/',
			name: t('Τράπεζα Eurobank'),
			afm: '996866969',
		},
	];
}
